import axios from 'axios'
import { Message } from 'element-ui'
import { getToken } from './token'
import {handleErrorResponse} from "./hadleRequestErrors";

const timer = 100 * 1000
    // axios

const service = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}/api`, // api base_url,
    headers: {
        Accept: 'application/json'
    },
    timeout: timer // time out for request
})
service.defaults.headers['Content-Type'] = 'application/json'

// request
service.interceptors.request.use(
    config => {
        if (!config.notAuthorized) {
            config.headers['Authorization'] = getToken()
        } else {
            delete config.headers['Authorization']
        }
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response
service.interceptors.response.use(
    response => {
        if (response.config.responseType === 'arraybuffer') {
            if (response.status !== 200 && response.status !== 201) {
                return Promise.reject('error')
            } else {
                return response
            }
        }

        const res = response.data
        if (response.status !== 200 && response.status !== 201) {
            Message({
                message: res.message,
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject('error')
        } else {
            return response.data
        }
    },
    error => handleErrorResponse(error)
)

export default service